// extracted by mini-css-extract-plugin
export default {"first_login":"login__first_login","description":"login__description"};